import React from 'react';
import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';
import {
    IconA,
    IconB,
    IconC,
    IconD,
    IconE,
    IconF,
    IconG,
    IconH,
    IconI,
    IconJ,
    IconK,
    IconL,
    IconM,
    IconN,
    IconO,
    IconP,
    IconQ,
    IconR,
    IconS,
    IconT,
    IconU,
} from './icons';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const IndustryLeadingC: React.FC = () => {
    const { t } = useLang('Delta3MaxSeriesStation.IndustryLeadingC');
    const itemsDescData = [
        {
            title: t('title_a'),
            desc1: t('desc_a'),
            iconList: [
                {
                    icon: <IconA />,
                    name: t('icon_name_a_1'),
                },
                {
                    icon: <IconB />,
                    name: t('icon_name_a_2'),
                },
                {
                    icon: <IconC />,
                    name: t('icon_name_a_3'),
                },
                {
                    icon: <IconD />,
                    name: t('icon_name_a_4'),
                },
            ],
        },
        {
            title: t('title_b'),
            desc1: t('desc_b'),
            iconList: [
                {
                    icon: <IconE />,
                    name: t('icon_name_b_1'),
                },
                {
                    icon: <IconF />,
                    name: t('icon_name_b_2'),
                },
                {
                    icon: <IconG />,
                    name: t('icon_name_b_3'),
                },
                {
                    icon: <IconH />,
                    name: t('icon_name_b_4'),
                },
            ],
        },
        {
            title: t('title_c'),
            desc1: t('desc_c'),
            iconList: [
                {
                    icon: <IconI />,
                    name: t('icon_name_c_1'),
                },
                {
                    icon: <IconJ />,
                    name: t('icon_name_c_2'),
                },
                {
                    icon: <IconK />,
                    name: t('icon_name_c_3'),
                },
                {
                    icon: <IconL />,
                    name: t('icon_name_c_4'),
                },
                {
                    icon: <IconM />,
                    name: t('icon_name_c_5'),
                },
                {
                    icon: <IconN />,
                    name: t('icon_name_c_6'),
                },
            ],
        },
        {
            title: t('title_d'),
            desc1: t('desc_d'),
            iconList: [
                {
                    icon: <IconO />,
                    name: t('icon_name_d_1'),
                },
                {
                    icon: <IconP />,
                    name: t('icon_name_d_2'),
                },
                {
                    icon: <IconQ />,
                    name: t('icon_name_d_3'),
                },
                {
                    icon: <IconR />,
                    name: t('icon_name_d_4'),
                },
                {
                    icon: <IconS />,
                    name: t('icon_name_d_5'),
                },
                {
                    icon: <IconT />,
                    name: t('icon_name_d_6'),
                },
                {
                    icon: <IconU />,
                    name: t('icon_name_d_7'),
                },
            ],
        },
    ];

    const getContent = (index: number) => {
        const data = itemsDescData[index];

        return (
            <div className="desc-card">
                <div className="card-title">{data.title}</div>
                <div className="card-desc">{data.desc1}</div>
                <div className="icon-list">
                    {data.iconList.map((item, index) => (
                        <div className="icon-item" key={index}>
                            <span className="icon">{item.icon}</span>
                            <span className="use-name">{item.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <section className={`${styles.IndustryLeadingC} GtmModuleData-section`} data-section-id={'IndustryLeadingC'}>
            <div className="industry-bg-wrap">
                <EcoFaqWithImg
                    className="section-card-faq"
                    imgHeight="1-1"
                    items={[
                        {
                            desc: getContent(0),
                            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1760967084435-ot8jaq-compressed-2000Wh.jpg',
                            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1760967084435-ot8jaq-compressed-2000Wh.jpg',
                            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1760967116105-1910rk-compressed-Frame%202094654315.jpg',
                            title: t('header_a'),
                        },
                        {
                            desc: getContent(1),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1757660708006/4000Wh.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1757660708006/4000Wh.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757901540155/app3.jpg',
                            title: t('header_b'),
                        },
                        {
                            desc: getContent(2),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1757660708113/6000Wh.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1757660708113/6000Wh.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757901539613/app3%20(1).jpg',
                            title: t('header_c'),
                        },
                        {
                            desc: getContent(3),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1757660708267/10000Wh.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1757660708267/10000Wh.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757901539443/app3%20(2).jpg',
                            title: t('header_d'),
                        },
                    ]}
                />
                <div className="tips">{t('tips')}</div>
            </div>
        </section>
    );
};

export default IndustryLeadingC;
